import React, { Component } from "react";
import _ from "lodash";

import { Grid, Paper, Typography } from "@material-ui/core";

import { WithStyles, createStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import {
  MyPATLink,
} from "../../../../common";

import ContentData from "../../../types/ContentData";
import SelectedQuestionBenchmarks from '../SelectedQuestionBenchmarks';
import { QuestionBenchmarks } from "../../../types/Benchmarks";
import { getTime, getTimeUnit } from "../../../../../utils/getOffset.utils";
import { OBJECTIVE_NOTES, SUBJECTIVE_NOTES } from '../../../../../constants/comman';

const styles = (theme: Theme) =>
  createStyles({
    contentPaddingRight: {
      paddingRight: '25px',
    },
    keyValueContainer: {
      "& *": {
        display: "inline",
        marginRight: "4px",
      },
      marginTop: theme.spacing.unit * 2,
    },

    overviewMeta: {
      opacity: 0.6,
    },

    metaInfoBox: {
      padding: theme.spacing.unit,
      marginTop: theme.spacing.unit,
      background: "#FDFDFD",
      border: "1px solid #DDDDDD",
      boxSizing: "border-box",
      borderRadius: 4,
    },

    metaInfoBoxTable: {
      border: 0,
    },

    paddingSM: {
      padding: 16,
    },

    titleDesc: {
      marginTop: theme.spacing.unit * 2,
      "& p": {
        margin: 0,
        fontSize: 16
      },
      "& p > img, img": {
        maxWidth: "100%",
      },
    },

    optionText: {
      display: "flex",
      whiteSpace: "nowrap",
      margin: "4px 0px",
      lineHeight: "38px",
      "& > span > p": {
        display: "inline",
        marginLeft: theme.spacing.unit,
      },
    },

    tagsList: {
      display: "inline-block",
      verticalAlign: "middle",
      marginRight: theme.spacing.unit,
      "&:after": {
        content: '"|"',
        marginLeft: theme.spacing.unit,
      },
      "&:last-child": {
        marginRight: 0,
        "&:after": {
          display: "none",
        },
      },
    },

    wrapText: {
      clear: "both",
      width: "100%",
      display: "inline-block",
      maxWidth: "96%",
      overflowX: "auto",
      whiteSpace: "initial",
      overflowY: "hidden",
      "& p": {
        margin: "0px",
        textAlign: "justify",
      },
    },

    widthSet: {
      width: "100%",
      "& .MyPATExpansionPanel-greyBackground-452": {
        backgroundColor: "#fff",
        background: "#fff !important",
      },
    },

    fontSM: {
      fontWeight: 600,
      fontSize: "1rem",
      lineHeight: "22px",
      color: "#333333",
    },

    fontXS: {
      fontWeight: 600,
      fontSize: "0.8rem",
      color: "#333",
    },

    blueColor: {
      color: "#1D7DEA",
    },

    greyColor: {
      color: "#333333",
    },
    inlineChildren: {
      "& > *": {
        display: "inline-block",
        margin: "0"
      },
      "& > h4": {
        fontWeight: "normal"
      }
    },
    scenario: {
      "& > *": {
        margin: "0"
      },
      "& > h4": {
        fontWeight: "normal"
      }
    }
  });

//@ts-ignore
interface QuestionPreviewProps extends WithStyles<typeof styles> {
  classes: any;
  content: any;
  questionBenchmarks: QuestionBenchmarks;
  tags: any;
  notesData:any;
}

interface QuestionPreviewStates { }

class QuestionPreview extends Component<QuestionPreviewProps, QuestionPreviewStates> {
  constructor(props: QuestionPreviewProps) {
    super(props);

    this.getConceptsTagged = this.getConceptsTagged.bind(this);
    this.getSolutionContent = this.getSolutionContent.bind(this);
  }

  getConceptsTagged() {
    const { content, classes } = this.props;

    return _.reduce(
      _.get(content, "metaData.question.id.subjects", []),
      (acc: JSX.Element[], s) => {
        s.chapters.forEach((c: any) => {
          c.concepts.forEach((cc: any) => {
            let conceptName = _.get(cc, "conceptId.name");
            let conceptCode = _.get(cc, "conceptCode");
            if (conceptName) {
              acc.push(
                <Typography variant="body1">
                  {/* {conceptName}{" "} */}
                  {conceptCode && (
                    <Typography variant="h6" inline className={classes.fontXS}>
                      (ID: {conceptCode})
                    </Typography>
                  )}
                </Typography>
              );
            }
          });
        });
        return acc;
      },
      []
    );
  }

  getSolutionContent(solutionContent: any) {
    return solutionContent === ("<p> <br></p>" || "")
      ? "Not Available"
      : solutionContent;
  }

  renderTolerance(value: any) {
    if (value || value == 0) {
      return value;
    }
    return "Not Defined";
  }

  getIdealTime(time: number) {
    return `${getTime(time)} ${getTimeUnit(time)}`
  }

  getTitleForNotes() {
    return this.checkPracticeSetNotes() ? "Question" : "Page";
  }

  checkPracticeSetNotes() {
    const notesType = _.get(this.props.notesData, 'content.subType', '');

    return OBJECTIVE_NOTES.includes(notesType) || SUBJECTIVE_NOTES.includes(notesType);
  }

  getSubHeading() {

    const { content } = this.props;
    const subHeading = (_.get(content, "metaData.question.subHeading", "") || '').trim();

    const defaultSubHeading = this.checkPracticeSetNotes() ? '' : "Not Available";

    return subHeading || defaultSubHeading;
  }


  getScenario() {
    const { content } = this.props;
    const scenario = _.get(content, "metaData.question.id.content[0].passageQuestion", '');

    const defaultScenario = this.checkPracticeSetNotes() ? '' : 'Not Available';

    return scenario || defaultScenario;
  }

  render() {

    const { classes, content, questionBenchmarks, tags = [] } = this.props;
    const subHeading = this.getSubHeading();
    const passageId = _.get(content, "metaData.question.passageId", '');
    const scenario = this.getScenario();

    return (
      <Grid container spacing={16} direction="column">
        <Grid item className={classes.widthSet}>
          <Paper className={classes.paddingSM}>
            <div><h3>{this.getTitleForNotes()} {content.pageNumber}</h3></div>
            {subHeading &&
              <div className={classes.inlineChildren}>
                <h4>Sub Heading</h4>:&nbsp;<div>
                  <Typography variant="body1">
                    <span dangerouslySetInnerHTML={{ __html: subHeading, }} className={classes.imgContainer} />
                  </Typography>
                </div>
              </div>
            }
            {
              passageId && passageId.length && scenario &&
              <div className={classes.scenario}>
                <h4>Scenario :&nbsp;</h4><div>
                  <Typography variant="body1">
                    <div dangerouslySetInnerHTML={{ __html: scenario }}>
                    </div>
                  </Typography>
                </div>
              </div>
            }
            <div className={classes.metaInfoBox}>
              <Grid container>
                <Grid item xs={4}>
                  <Typography
                    variant="body2"
                    className={[classes.fontSM, classes.greyColor].join(" ")}
                  >
                    Question Type:{" "}
                  </Typography>
                  <Typography variant="body1">
                    {_.get(content, "metaData.question.id.questionType", "")}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography
                    variant="body2"
                    className={[classes.fontSM, classes.greyColor].join(" ")}
                  >
                    Difficulty:{" "}
                  </Typography>
                  <Typography
                    variant="body1"
                    style={{ textTransform: "capitalize" }}
                  >
                    Level:{" "}
                    {_.get(content, "metaData.question.id.difficultyLevel", []).join(", ")}{" "}
                    <br />
                    Type:{" "}
                    {_.get(content, "metaData.question.id.difficultyType", []).join(", ")}
                  </Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography
                    variant="body2"
                    className={[classes.fontSM, classes.greyColor].join(" ")}
                  >
                    Attempt Question
                  </Typography>
                  {_.get(content, "metaData.question.attempt", false) ? 'Mandatory' : 'Optional'}
                </Grid>
              </Grid>
            </div>
            <div className={classes.titleDesc}>
              <Typography
                variant="body2"
                className={[classes.fontSM, classes.greyColor].join(" ")}
              >
                Question:{" "}
              </Typography>
              <Typography variant="body1">
                <span
                  dangerouslySetInnerHTML={{
                    __html: _.get(
                      content,
                      "metaData.question.id.content[0].questionContent",
                      "-"
                    ),
                  }}
                />
              </Typography>
              <Typography variant="body1" noWrap>
                ID: <span><MyPATLink to={`/content/preview/${_.get(content, "metaData.question.id._id", "")}question`} target="_blank">
                  {_.get(
                    content,
                    "metaData.question.id.contentId",
                    ""
                  ).toUpperCase()
                  }
                </MyPATLink></span>
              </Typography>
            </div>

            <div className={classes.titleDesc}>
              {!_.includes(
                ["3", "4", "6", "7"],
                content.metaData.question.id && content.metaData.question.id.questionCode && content.metaData.question.id.questionCode.toString()
              ) && (
                  <>
                    <Typography variant="body2" className={classes.fontSM}>
                      Options are:{" "}
                    </Typography>
                    <Typography variant="body1" component="div">
                      {_.map(
                        _.get(content, "metaData.question.id.content[0].optionsContent", []),
                        (o, i: number) => (
                          <div key={i} className={classes.optionText}>
                            <span>&#40;{o.id}&#41;</span>&nbsp; &nbsp;{" "}
                            <div
                              className={classes.wrapText}
                              dangerouslySetInnerHTML={{ __html: o.value }}
                            />
                          </div>
                        )
                      )}
                    </Typography>
                  </>
                )}
              <div>
                <Typography variant="body2" className={classes.fontSM}>
                  Correct Answer:{" "}
                </Typography>
                <Typography variant="body1">
                  {_.map(
                    _.get(content, "metaData.question.id.content[0].correctAnswer.data", []),
                    (o, i: number) =>
                      content.metaData.question.id.questionCode && content.metaData.question.id.questionCode.toString() === "6" ? (
                        <span key={i}>
                          <div>{o.value}</div>
                          <div>
                            Positive Tolerance :{" "}
                            {this.renderTolerance(o.positiveTolerance)}
                          </div>
                          <div>
                            Negative Tolerance :{" "}
                            {o.negativeTolerance > 0 && "-"}
                            {this.renderTolerance(o.negativeTolerance)}
                          </div>
                        </span>
                      ) : (
                          <span
                            key={i}
                            dangerouslySetInnerHTML={{ __html: o.value }}
                          />
                        )
                  )}
                </Typography>
                {/* {_.get(content, "metaData.question.id.content[0].correctAnswer.data", [])
                  .length == 0 && (
                    <Typography variant="body1" color="error">
                      Answer must be entered in a question
                  </Typography>
                  )} */}
              </div>
              <div className={classes.titleDesc}>
                <Typography variant="body2" className={classes.fontSM}>
                  idealTime:{" "}
                </Typography>
                <Typography variant="body1">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: this.getIdealTime(
                        _.get(content, "content.settings.idealTimeToSolve", '')
                      ),
                    }}
                  />
                </Typography>
              </div>
              <div className={classes.titleDesc}>
                <Typography variant="body2" className={classes.fontSM}>
                  Solutions:{" "}
                </Typography>
                <Typography variant="body1">
                  <span
                    dangerouslySetInnerHTML={{
                      __html: this.getSolutionContent(
                        _.get(content, "metaData.question.id.content[0].solutionContent", [])
                      ),
                    }}
                  />
                </Typography>
              </div>
              <div className={classes.titleDesc}>
                <Typography variant="body2" className={classes.fontSM}>
                  Tags:{" "}
                </Typography>
                <Typography variant="body1" className={classes.contentPaddingRight}>
                  {tags && tags.length && tags.map((t: any, i: number) => (
                    <span className={classes.tagsList} key={i}>
                      {_.get(t, "relation.name", "-")}
                      {": "}
                      {_.isArray(_.get(t, "values", "-"))
                        ? _.get(t, "values", "-").join(", ")
                        : _.get(t, "values", "-")}
                    </span>
                  ))}
                </Typography>
              </div>
              <Typography variant="body2" className={classes.fontSM}>
                Instruction:{" "}
              </Typography>
              <Typography variant="body1">
                <span
                  dangerouslySetInnerHTML={{
                    __html: this.getSolutionContent(
                      _.get(content, "metaData.question.instruction", [])
                    ),
                  }}
                />
              </Typography>
            </div>
          </Paper>
        </Grid>
      </Grid>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(QuestionPreview);